import WalletLogo from './WalletLogo';

export default WalletLogo;
